import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import { xContext } from "../context/userContext";
import { useNavigate } from "react-router-dom";
import BounceLoader from "react-spinners/BounceLoader";
import swal from "sweetalert";
import Footer from "./footer";

const Apply = () => {
  const [selectedFile, setSelectedFile] = useState("");
  const [amount, setAmount] = useState(0);
  const [occupation, setOccupation] = useState();
  const [security, setSecurity] = useState();
  const [name, setName] = useState();
  const [months, setMonths] = useState();
  const [phone, setPhone] = useState(260);
  const [loading, setLoading] = useState(0);
  const navigate = useNavigate();

  const topRef = useRef(null);

  const ctx = useContext(xContext);

  useEffect(() => {
    topRef.current.scrollIntoView({ behavior: "smooth" });
    setAmount(ctx.amount);
    setMonths(ctx.months);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(1);

    axios

      .post("https://farmserver.pickmesms.com/applyloan", {
        amount: amount,
        occupation: occupation,
        security: security,
        phone: phone,
        name: name,
      })
      .then((res) => {
        setLoading(0);
        if (res.data.result === 200) {
          swal({
            text: "Your request was successful",
            icon: "success",
          }).then(() => {
            navigate("/");
          });
        }
        setAmount("");
        setOccupation("");
        setSecurity("");
        setPhone("");
      })
      .catch((err) => {
        // console.log(err);
        swal({
          text: "An Error occured. Please contact support",
          icon: "warning",
        });
        setLoading(0);
      });
  };

  return (
    <>
      <div className="stricky-header stricked-menu main-menu">
        <div className="sticky-header__content" />
        {/* /.sticky-header__content */}
      </div>
      {/* /.stricky-header */}
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(assets/images/apply.jpg)",
          }}
        />
        {/* /.page-header__bg */}
        <div ref={topRef} className="container">
          <ul className="thm-breadcrumb list-unstyled">
            <li>
              <a href="index.html">Home</a>
            </li>
            <li>/</li>
            <li>
              <span>Apply</span>
            </li>
          </ul>
          {/* /.thm-breadcrumb list-unstyled */}
          <h2 style={{ color: "#A1D235" }}>Apply</h2>
        </div>
        {/* /.container */}
      </section>
      {/* /.page-header */}
      <section className="apply-one">
        <div className="container">
          <form onSubmit={handleSubmit} className="contact-one__form">
            <div className="contact-one__form-box">
              <div className="row">
                <div className="col-md-12">
                  <div className="block-title">
                    <h2 className="title-block">Loan Details</h2>
                  </div>
                  {/* /.block-title*/}
                </div>
                {/* /.col-md-12*/}
              </div>
              {/* /.row*/}
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Full Name</label>
                    <input
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                      name="name"
                      className="form-control contact-one__form-input"
                      placeholder="Full Name"
                      required=""
                    />
                  </div>
                  {/* /.form-group*/}
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Loan Amount*</label>
                    <input
                      onChange={(e) => setAmount(e.target.value)}
                      value={amount}
                      type="number"
                      name="loanamount"
                      className="form-control contact-one__form-input"
                      placeholder="Loan Amount"
                      required=""
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Occupation*</label>
                    <input
                      onChange={(e) => setOccupation(e.target.value)}
                      value={occupation}
                      name="income"
                      placeholder="Your current Occupation"
                      className="form-control contact-one__form-input"
                      required=""
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Security being used</label>
                    <input
                      onChange={(e) => setSecurity(e.target.value)}
                      value={security}
                      name="purpose"
                      className="form-control contact-one__form-input"
                      required=""
                    />
                  </div>
                  {/* /.form-group*/}
                </div>
                {/* /.col-md-6*/}
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Phone number</label>
                    <input
                      onChange={(e) => setPhone(e.target.value)}
                      value={phone}
                      type="number"
                      name="months"
                      className="form-control contact-one__form-input"
                      placeholder="Phone number starting with 260"
                      required=""
                    />
                  </div>
                  {/* /.form-group*/}
                </div>

                {/* /.col-md-6*/}
              </div>
              {/* /.row*/}
            </div>

            {loading === 1 ? (
              <div className="col-md-12" style={{ float: "right" }}>
                <div className="form-group">
                  <BounceLoader size={35} color={"#808080"} loading={true} />
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="contact-one__form-submit">
              <div className="row">
                <div className="col-md-12">
                  <input
                    type="submit"
                    defaultValue="Submitr"
                    className="thm-btn"
                  />
                </div>
                {/*/.col-md-12*/}
              </div>
              {/*/.row*/}
            </div>
            {/*/.contact-one__form-submit*/}
          </form>
          {/* /.contact-one__form*/}
        </div>
        {/* /.container*/}
      </section>

      <Footer />

      <div className="bottom-footer">
        <div className="container">
          <p>© Copyright 2021 by Century Loans</p>

          {/* /.bottom-footer__social */}
        </div>
        {/* /.container */}
      </div>

      <div className="mobile-nav__wrapper">
        <div className="mobile-nav__overlay mobile-nav__toggler" />
        {/* /.mobile-nav__overlay */}
        <div className="mobile-nav__content">
          <span className="mobile-nav__close mobile-nav__toggler" />
          <div className="logo-box">
            <a href="#" aria-label="logo image">
              <img src="assets/images/logo-light.png" width={155} alt="" />
            </a>
          </div>
          {/* /.logo-box */}
          <div className="mobile-nav__container" />
          {/* /.mobile-nav__container */}
          <ul className="mobile-nav__contact list-unstyled">
            <li>
              <i className="pylon-icon-email1" />
              <a href="#">info@centuryloans</a>
            </li>
            <li>
              <i className="pylon-icon-telephone" />

              <a href="tel:+260779244370">+260779244370</a>
            </li>
          </ul>
        </div>
      </div>

      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <i className="fa fa-angle-up" />
      </a>
    </>
  );
};

export default Apply;
